// tslint:disable
/**
 * まなびスタンプ enum定義
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * コースID
 * @export
 * @enum {string}
 */
export enum CourseId {
    calc = 'calc',
    japanese = 'japanese',
    number = 'number',
    word = 'word'
}

/**
 * HTTPステータスコード
 * @export
 * @enum {string}
 */
export enum HttpStatusCode {
    badRequest = 400,
    unauthorized = 401,
    forbidden = 403,
    notFound = 404,
    requestTimeout = 408,
    internalServerError = 500
}

/**
 * 無効フラグ(0：有効、1：無効)
 * @export
 * @enum {string}
 */
export enum InvalidFlag {
    off = 0,
    on = 1
}

/**
 * 結果No(0：未、1：〇、2：✖)
 * @export
 * @enum {string}
 */
export enum ResultNo {
    yet = 0,
    success = 1,
    fail = 2
}

/**
 * 教室種別(0：一般、1：まなびポケット、2：GoogleSSO、3：ベスプラ)
 * @export
 * @enum {string}
 */
export enum RoomType {
    normal = 0,
    manabi = 1,
    google = 2,
    bespra = 3
}

/**
 * ユーザー種別(0：通常、1：体験、2：こんぷ、3：コンプまえ、4：正解　※「1：体験」はDBに登録しないユーザー)
 * @export
 * @enum {string}
 */
export enum UserType {
    normal = 0,
    guest = 1,
    complete = 2,
    oneUnitLeft = 3,
    correct = 4
}


/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * dummy path
         * @summary dummy path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dummyGet(options: any = {}): RequestArgs {
            const localVarPath = `/dummy`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    return {
        /**
         * dummy path
         * @summary dummy path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dummyGet(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = DefaultApiAxiosParamCreator(configuration).dummyGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * dummy path
         * @summary dummy path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dummyGet(options?: any): AxiosPromise<void> {
            return DefaultApiFp(configuration).dummyGet(options)(axios, basePath);
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * dummy path
     * @summary dummy path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public dummyGet(options?: any) {
        return DefaultApiFp(this.configuration).dummyGet(options)(this.axios, this.basePath);
    }

}


